export function getNewCookieStr(cookie: { key: string; value: string }[], originalCookieStr?: string) {
  const cookies: Record<string, string> =
    originalCookieStr?.split(';').reduce((prev, cur) => {
      const [k, v] = cur.trim().split('=');
      return { ...prev, [k]: v };
    }, {}) || {};

  cookie.forEach(({ key, value }) => {
    cookies[key] = value;
  });

  return Object.entries(cookies)
    .map(([k, v]) => `${k}=${v}`)
    .join('; ');
}
